<ul ngbNav #nav="ngbNav" [(activeId)]="activeId" class="nav-tabs">
    <li *ngFor="let item of items" [ngbNavItem]="item.id">
        <button ngbNavLink>{{item.category}}  <span class="photo-count">{{item.images.length}}</span></button>
        <ng-template ngbNavContent>
            <div class="view-outer">
                <div class="row row-cols-2 row-cols-md-4 row-cols-lg-5">
                    <div class="img-block" *ngFor="let img of item.images">
                        <img [src]="img.src" alt="Image">
                    </div>
                </div>
                <p class="text-center mt-5" *ngIf="item.images.length == 0">No Record Found!</p>
            </div>
        </ng-template>
    </li>
</ul>

<div [ngbNavOutlet]="nav" class="mt-2"></div>
